// extracted by mini-css-extract-plugin
export var pillWrapper = "_pk-0";
export var showOverflow = "_pk-1";